import { LoginDataSliceState } from './store/logInDataSlice';

export function isUserLoggedIn(state: LoginDataSliceState) {
  return state.logInData.loggedInUser != null;
}

export function getUserEmail(state: LoginDataSliceState) {
  const { loggedInUser } = state.logInData;
  if (loggedInUser) {
    return loggedInUser.email;
  }
  return '';
}
